import React from "react";
import {
  NumericFormat,
  NumericFormatProps,
  PatternFormat
} from "react-number-format";
import MaskedInput from "react-text-mask";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

export const NumberInput = React.forwardRef(function NumberInput(
  props: any,
  ref
) {
  const { onChange = () => {}, ...other } = props;

  return (
    <NumericFormat
      allowLeadingZeros
      {...other}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      getInputRef={ref}
    />
  );
});

export const PercentInput = React.forwardRef(function NumberInput(
  props: any,
  ref
) {
  const { onChange = () => {}, ...other } = props;

  return (
    <NumericFormat
      {...other}
      suffix="%"
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      getInputRef={ref}
    />
  );
});

// export const MoneyInput = React.forwardRef(function MoneyInput(
//   props: any,
//   ref
// ) {
//   return (
//     <NumberInput
//       prefix={"$"}
//       thousandSeparator
//       allowNegative={false}
//       ref={ref}
//       {...props}
//     />
//   );
// });
export const MoneyInput = React.forwardRef<
  NumericFormatProps,
  CustomProps
>(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      valueIsNumericString
      prefix="$"
    />
  );
});

export const ThousandInput = React.forwardRef<
  NumericFormatProps,
  CustomProps
>(function NumericFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      valueIsNumericString
      allowedDecimalSeparators={["."]}
      prefix=""
    />
  );
});

export const PhoneMask = React.forwardRef(function PhoneMask(
  props: any,
  ref
) {
  const { onChange = () => {}, ...rest } = props;

  return (
    <PatternFormat
      format="(###) ###-####"
      mask="_"
      allownegative="false"
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      getInputRef={ref}
      {...rest}
    />
  );
});

export const CedulaMask = React.forwardRef(function CedulaMask(
  props: any,
  ref
) {
  const { onChange = () => {}, ...rest } = props;

  return (
    <PatternFormat
      format="###-#######-#"
      mask="_"
      allowNegative={false}
      getInputRef={ref}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      {...rest}
    />
  );
});

export const TextMaskInput = React.forwardRef(function TextMaskInput(
  props: any,
  ref
) {
  return (
    <MaskedInput
      mask={s => Array.from(s).map(() => /[\p{L}\p{M}\s]/iu)}
      guide={false}
      getInputRef={ref}
      {...props}
    />
  );
});

export const TextInputMask = React.forwardRef(function TextMaskInput(
  props: any,
  ref
) {
  return (
    <MaskedInput
      mask={s => Array.from(s).map(() => /[A-Za-z0-9,\- ]/)}
      guide={false}
      getInputRef={ref}
      {...props}
      onChange={values => {
        props.onChange({ target: { value: values.target.value } });
      }}
    />
  );
});

export type TFormatInputField =
  | "onlyNumber"
  | "PercentInput"
  | "MoneyInput"
  | "PhoneMask"
  | "CedulaMask"
  | "onlyText"
  | "ThousandInput"
  | "input";

export const getFieldMaskAndFormat = (type: TFormatInputField) => {
  if (type === "onlyText") {
    return TextMaskInput;
  } else if (type === "onlyNumber") {
    return NumberInput;
  } else if (type === "PercentInput") {
    return PercentInput;
  } else if (type === "MoneyInput") {
    return MoneyInput;
  } else if (type === "PhoneMask") {
    return PhoneMask;
  } else if (type === "CedulaMask") {
    return CedulaMask;
  } else if (type === "ThousandInput") {
    return ThousandInput;
  } else {
    return "input";
  }
};
